<template lang="pug">
section
  div
    | The Home Office Sponsorship Management System (SMS)
    | is an online portal
    | that allows employers
    | to fulfil their sponsorship duties.

  div
    | Initially only the Level 1 user
    | will have access to the SMS,
    | where they can grant access
    | to other personnel
    | as Level 1 or 2 users.

  br

  div
    | You can read guides published
    | by the Home Office on how to use SMS.
</template>

<script>
export default {
  name: "sms_general",
};
</script>